module.exports = __webpack_public_path__ + "img/alert_history.c4ab1a90.svg";